import {
  PRODUCTION_API_DOMAIN,
  STAGING_API_DOMAIN,
  LOCAL_API_DOMAIN,
  STAGING_DOMAIN,
  PRODUCTION_DOMAIN,
  LOCAL_DOMAIN,
} from "lib/constants";

const clearSubdomain = (domain: string) => {
  return domain.replace("www.", "");
};

export const parseLinkToEnv = (path: string) => {
  try {
    const url = new URL(path);

    if (!url.hostname) {
      return path;
    }

    switch (process.env.NEXT_PUBLIC_DEPLOYED_ENV) {
      case "staging":
      case "development": {
        const API_DOMAIN_TO_REPLACE = new URL(
          process.env.NEXT_PUBLIC_DEPLOYED_ENV === "development" ? LOCAL_API_DOMAIN : STAGING_API_DOMAIN
        );

        const DOMAIN_TO_REPLACE = new URL(
          process.env.NEXT_PUBLIC_DEPLOYED_ENV === "development" ? LOCAL_DOMAIN : STAGING_DOMAIN
        );

        const isApiDomain = clearSubdomain(url.hostname) === clearSubdomain(new URL(PRODUCTION_API_DOMAIN).hostname);

        const isSelfDomain = clearSubdomain(url.hostname) === clearSubdomain(new URL(PRODUCTION_DOMAIN).hostname);

        if (isApiDomain) {
          url.hostname = API_DOMAIN_TO_REPLACE.hostname;
          url.port = API_DOMAIN_TO_REPLACE.port;
          url.protocol = API_DOMAIN_TO_REPLACE.protocol;
        }

        if (isSelfDomain) {
          url.hostname = DOMAIN_TO_REPLACE.hostname;
          url.port = DOMAIN_TO_REPLACE.port;
          url.protocol = DOMAIN_TO_REPLACE.protocol;
        }

        return url.toString();
      }

      default:
        return path;
    }
  } catch {
    return path;
  }
};
